module.exports = "<ul class=\"ssf-permissions\" *ngIf=\"normalize(scopes).length > 0; else no_scopes\">\n    <li *ngFor=\"let scope of normalize(scopes)\">\n        <i class=\"fa fa-check-circle fa-lg ssf-permissions__icon\"></i>\n        {{scope | translate}}\n    </li>\n</ul>\n\n<ng-template #no_scopes>\n    <div class=\"ssf-permissions ssf-permissions_empty\">{{i18n + 'EMPTY' | translate}}</div>\n</ng-template>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/components/permissions/permissions.component.html
// module id = 656
// module chunks = 3